module.exports = __webpack_public_path__ + "img/WINTER HAT RED.744f18f.svg";